import compassIcon from '../assets/adventure-icons/compass.svg';
import mapIcon from '../assets/adventure-icons/map.svg';
import waterIcon from '../assets/adventure-icons/water.svg';
import foodIcon from '../assets/adventure-icons/food.svg';
import medicineIcon from '../assets/adventure-icons/medicine.svg';
import tentIcon from '../assets/adventure-icons/tent.svg';
import preparationBadgeIcon from '../assets/adventure-icons/preparation.svg';
import teamBadgeIcon from '../assets/adventure-icons/team.svg';
import sceneBadgeIcon from '../assets/adventure-icons/scene.svg';
import equipmentBadgeIcon from '../assets/adventure-icons/equipment.svg';
import dangerBadgeIcon from '../assets/adventure-icons/danger.svg';
import escapeBadgeIcon from '../assets/adventure-icons/escape.svg';

const EQUIPMENT_ICON_BY_ID: Record<string, string> = {
  compass: compassIcon,
  map: mapIcon,
  water: waterIcon,
  food: foodIcon,
  medicine: medicineIcon,
  tent: tentIcon,
};

const ADVENTURE_BADGE_ICON_BY_NAME: Record<string, string> = {
  整装待发: preparationBadgeIcon,
  慧眼识人: teamBadgeIcon,
  组队勋章: teamBadgeIcon,
  妙选场景: sceneBadgeIcon,
  精装上阵: equipmentBadgeIcon,
  启程勋章: equipmentBadgeIcon,
  生存勋章: equipmentBadgeIcon,
  巧设险局: dangerBadgeIcon,
  勇气勋章: dangerBadgeIcon,
  逃生高手: escapeBadgeIcon,
};

const isRemoteOrLocalAsset = (value?: string) => Boolean(value && /^(https?:)?\/\/|^\//.test(value));

export const getEquipmentIconSrc = (equipmentId: string) =>
  EQUIPMENT_ICON_BY_ID[equipmentId] ?? equipmentBadgeIcon;

export const getAdventureBadgeIconSrc = (badgeName: string, fallbackIcon?: string) => {
  if (ADVENTURE_BADGE_ICON_BY_NAME[badgeName]) {
    return ADVENTURE_BADGE_ICON_BY_NAME[badgeName];
  }

  if (isRemoteOrLocalAsset(fallbackIcon)) {
    return fallbackIcon!;
  }

  return escapeBadgeIcon;
};
